module.exports = __webpack_public_path__ + "media/Audio15_a.ed8b166e.wav";